import { TYPES } from './constants'

export default (() =>
  class Item {
    constructor(obj) {
      if (obj) {
        const { type, id } = obj
        this.type = type
        this.id = id
      }
      this.lastViewed = new Date()
    }

    set type(rawType) {
      const type = TYPES[rawType?.toUpperCase()]
      if (!type) {
        throw new Error(`Invalid type: ${rawType}`)
      }
      this._type = type
    }

    get type() {
      return this._type
    }

    serialize() {
      return {
        type: this.type,
        id: this.id,
        lastViewed: this.lastViewed.getTime()
      }
    }

    deserialize(obj) {
      this.type = obj.type
      this.id = obj.id
      this.lastViewed = new Date(obj.lastViewed)
    }
  })()
